module.exports = __webpack_public_path__ + "media/images/logo-ee339eb6bffd8541d0346d2bce428dca.svg";